import type { ReactNode } from "react";

import Header from "../../shell/Header";
import MobileDrawerMenu from "../../shell/MobileDrawerMenu";
import PaymentStatisticsModal from "../../../components/Payment/PaymentStatisticsModal";
import { useSelector } from "react-redux";
import classNames from "classnames";

type AppLayoutFrameProps = {
    children?: ReactNode;
    isMobileView: boolean;
    overlays?: ReactNode;
    showOpenPaymentsModal: boolean;
};

const AppLayoutFrame = ({
    children,
    isMobileView,
    overlays,
    showOpenPaymentsModal,
}: AppLayoutFrameProps) => {
    const isDemoMode = useSelector((state: RootState) => state.appGeneral.isDemoMode);

    return (
        <div className={classNames("page-wrapper", { "is-demo-mode": isDemoMode })}>
            <Header />

            {isMobileView && (
                <MobileDrawerMenu />
            )}

            <div id="main_content" className="main-content-wrap d-flex">
                <div className="container-fluid container-limited mb-1 d-flex flex-column">
                    {children}
                </div>
            </div>

            {showOpenPaymentsModal && (
                <PaymentStatisticsModal />
            )}

            {overlays}
        </div>
    );
};

export default AppLayoutFrame;
